import EdlinkTeacherClassesView from "@features/tools/view/edlink-teacher-classes-view";

const EdlinkTeacherClasses = () => {
  return <EdlinkTeacherClassesView />;
};

export default EdlinkTeacherClasses;
